<script>
import { authMethods } from '@state/helpers'
import layout from '@src/mixins/layout.vue'

export default {
  mixins: [layout],
  data() {
    return {
      chat: null,
      message: '',
    }
  },
  methods: {
    ...authMethods,
    async goToDashboardScreen() {
      this.$router.push({ name: 'safehaven-dashboard' })
    },
  },
}
</script>

<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" md="12" :class="$style.mainContainer">
          <p :class="$style.headerText">Secure Chat has ended</p>
          <v-btn
            class="text-capitalize"
            rounded
            :width="notDesktop ? '300px' : '271px'"
            height="45px"
            :class="$style.returnBtn"
            @click="goToDashboardScreen"
          >
            Return to dashboard
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style lang="scss" module>
@import '@design';

.headerText {
  font-size: 28px;
  font-weight: 400;
  line-height: 38px;
  color: #000;
  text-align: center;
  letter-spacing: -0.30000001192092896px;
}

.returnBtn {
  margin-top: 25px;
  font-size: 18px !important;
  font-weight: 600;
  line-height: 27px;
  color: #fff !important;
  text-align: center;
  letter-spacing: 0;
  background-color: #0476d9 !important;
  border-radius: 32px;
}

.mainContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  margin-top: 70px;
}
</style>
